export const DropdownMenuPosition = {
  BottomLeft: 'bottom-left',
  TopLeft: 'top-left',
  TopRight: 'top-right',
  BottomRight: 'bottom-right',
};
